import { connect } from 'react-redux';
import FiltersContainer from './filters-container';

const mapStateToProps = (state) => ({
  isFetching: state.news?.newsSources.isFetching,
  newsSources: state.news?.newsSources.allNewsSources,
});

export default connect(mapStateToProps)(FiltersContainer);
